import instance from "@/helpers/axios"


export const approvedNicheModule = {
  namespaced: true,
  state: {
    nicheList: [],
    loading: false,
  },
  getters: {
    nicheItems: (state) => state.nicheList.data,
  },
  mutations: {
    SET_NICHE_LIST(state, list) {
      state.nicheList = list
    },
    SET_LOADING(state, val) {
      state.loading = val
    },
  },
  actions: {
    async fetchNicheList({ commit }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await  instance.get('/api/outreach/approverfor/niche/all')
        commit('SET_NICHE_LIST', data)
      } catch (e) {
        console.error(e)
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}